@if (showAssignmentComponent) {
  <div class="row">
    <div class="col-12">
      <div class="container-fluid p-2 border bg-light mb-2">
        <div class="row">
          <div class="col-6">
            <app-provider-data-review-assignments
              [displayForList]="true"
              (assignmentUpdate)="onAssignmentUpdate($event)"
              (assignmentClearSelection)="onAssignmentClearSelection()"
            />
          </div>
          <div class="col-6 text-end pt-5">
            {{ selectedCount }} provider reviews selected
            @if (totalCount) {
              | {{ totalCount }} provider reviews
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      <th>NPI</th>
      <th>Name</th>
      <th>Client</th>
      <th>Status</th>
      <th>Provider Status</th>
      <th>Review Type</th>
      @if (showAssignedToCol) {
        <th class="text-nowrap">Assigned To</th>
      }
      <th>Specialties</th>
      <th>Offices</th>
      <th>Created On</th>
      <th>Nearest Expiration</th>
      <th>Estimated Value</th>
      <th>Priority</th>
    </tr>
  </thead>
  <tbody>
    @for (dataReview of dataReviews; track dataReview) {
      <tr [ngClass]="{ 'selected' : isProviderDataReviewSelected(dataReview) }">
        <td class="text-nowrap">
          @if (canManageProviderData) {
            <input
              type="checkbox"
              [checked]="isProviderDataReviewSelected(dataReview)"
              (click)="onProviderDataReviewClick($event, dataReview)"
              class="me-1" />
          }
          <a target="_blank" href="/capture-admin/providers/{{ dataReview.provider.npi}}">
            {{ dataReview.provider.npi }}
          </a>
          <app-copy-to-clipboard [text]="dataReview.provider.npi" />
          <div>
            <app-user-presence category="provider" [targetId]="dataReview.provider.id" class="ms-3"/>
          </div>
        </td>
        <td>
          {{ dataReview.provider.fullName | blankValueDash }}
        </td>
        <td>
          {{ dataReview.clientNames?.join(', ') | blankValueDash }}
        </td>
        <td>
          {{ dataReview.status | titlecase }}
        </td>
        <td>
          {{ keyedProviderStatusOptions[dataReview.provider.status]?.display | blankValueDash }}
        </td>
        <td>
          {{ keyedProviderDataReviewTypeOptions[dataReview.type]?.display | blankValueDash }}
        </td>
        @if (showAssignedToCol) {
          <td>
            @if (dataReview.assignedTo) {
              {{ dataReview.assignedTo.fullName }}
            } @else {
              <app-blank-value-dash />
            }
          </td>
        }
        <td>
          {{ dataReview.provider.specialties.join(', ') }}
        </td>
        <td>
          @if (dataReview.offices.length > 0) {
            <app-office [office]="dataReview.offices[0]" />
            @if (dataReview.offices.length > 1) {
            <div>
              <a class="all-offices"
                href="/capture-admin/providers/{{ dataReview.provider.npi }}"
                target="_blank">
                View All Offices
              </a>
            </div>
            }
          }
          @if (dataReview.offices.length === 0) {
            <app-blank-value-dash />
          }
        </td>
        <td>
          {{ dataReview.createdAt | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          {{ dataReview.nearestExpirationDate | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          {{ dataReview.estimatedValue }}
        </td>
        <td>
          {{ dataReview.priority }}
        </td>
      </tr>
    }
  </tbody>
</table>